import React from 'react';
import styled from "@emotion/styled"
import breakpoints from '../../styles/breakpoints.js';

const Footer =() =>
{
  return(
    <FooterWrapper>
      <div>&copy; 2021 Inter-Dimension Connect +<br/>本網站所有影音圖文版權均為其創作者所有。</div>
    </FooterWrapper>
  );

}

export default Footer;

const FooterWrapper = styled.footer`
  padding:0 64px;
  height:90px;
  background:#CCCCCC;
  text-align:center;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:14px;
  position:relative;
  z-index:10;

  @media all and (max-width: ${breakpoints.xsMax}){
    padding:0 16px;
  }
`